<template>
  <div class="auth">
    <filter-panel :data="groups"
                  @search="filterChange"></filter-panel>
    <el-row type="flex"
            class="row-bg"
            justify="space-between">
      <h2 style="margin: 0;">总数: {{page.totalRecords}}</h2>
      <el-button size="medium"
                 @click="dialogVisible = true"
                 type="primary">新增</el-button>
    </el-row>
    <data-list :table-style='{name:"mixture"}'
               :data="data"
               :columns="column"
               :loading="loading"
               :page="page"
               :page-size="page.pageSize"
               @page-size-changed="pageSizeChanged"
               @page-changed="pageChanged"
               @sort-change="sortChange"></data-list>
    <el-dialog :close-on-click-modal="false"
               :title="accountForm.id ? '编辑账户':'新增账户'"
               @close="close"
               :visible.sync="dialogVisible"
               width="600px">
      <form-combination :form-data="formData"
                        ref="formData"
                        label-width="120px">
      </form-combination>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary"
                   @click="submit"
                   :loading="btnLoading">{{accountForm.id ? '保存':'确认并授权'}}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import filterPanel from "@/components/iglobalwin/filterPanelNew/filterPanel.vue";
import account from "@/backend/services/account/account";
import mediafax from "@/backend/services/account/mediafax.js";
import api from "@/backend/apiConfig/apiConfig";
import listPageCreate from "@/mixins/listPageCreate";
import { mediaPlatForm, authStatus, genreSatus } from "@/common/dictionary";
import formCombination from "@/components/iglobalwin/formCombination/formCombination.vue";
import simpleFormPageCreate from "@/components/iglobalwin/formCombination/formService.js";
import vm from "@/common/confirm.js";
import beforeRouteEnter from "@/mixins/beforeRouteEnter.js";
const datalist = listPageCreate({
  searchConfig: {
    api: api.account.getAccountList,
    method: "POST"
  }
});
export default {
  name: "socialMedialAuth",
  components: {
    filterPanel,
    formCombination
  },
  mixins: [datalist, beforeRouteEnter],
  data () {
    const that = this;
    const groups = {
      mainSearchInput: {
        prop: "account",
        placeholder: "运营账号",
        value: undefined
      },
      others: [
        {
          tagName: "sky-input",
          prop: "thirdpartyAccountName",
          placeholder: "Facebook账号",
          label: "Facebook账号",
          value: undefined
        }
      ],
      multiples: [
        {
          prop: "authorizationState",
          defaultText: "授权状态",
          label: "授权状态",
          options: authStatus,
          value: undefined
        },
        {
          prop: "genre",
          defaultText: "账号归属",
          label: "账号归属",
          options: genreSatus,
          value: undefined
        }
      ]
    };
    const column = [
      {
        //1  未授权  2  已授权   3  已封
        label: "绑定状态",
        type: "mapping",
        bind: "status",
        mapType: "iconfont",
        align: "left",
        size: { fontSize: "23px" },
        parentEvent: row => {
          let status = [
            { label: "remind1", value: 1 },  // 未授权
            { label: "fasongchenggong", value: 2 },  // 已授权
            { label: "fasongshibai1", value: 3 }  // 已封
          ];
          return status.find(item => row == item.value).label;
        },
        colors: row => {
          let status = [
            { label: { color: "#FCC262" }, value: 1 },
            { label: { color: "#78CE4D" }, value: 2 },
            { label: { color: "#FF5A5A" }, value: 3 }
          ];
          return status.find(item => row.status == item.value).label;
        },
        message: row => {
          let status = [
            { label: "未授权", value: 1 },
            { label: "已授权", value: 2 },
            { label: "已封", value: 3 }
          ];
          return status.find(item => row.status == item.value).label;
        }
      },
      {
        label: "账号归属客户",
        bind: "genreName"
      },
      {
        label: "FB主页名称",
        bind: "account"
      },
      {
        label: "FB主页ID",
        bind: "thirdpartyAccountName"
      },
      {
        label: "FB广告ID（FBID）",
        bind: "thirdparyPageCount"
      },
      {
        label: "初次授权日期",
        bind: "createDate"
      },
      {
        label: "授权有效期",
        bind: "remindDate"
      },
      // {
      //   label: '剩余日期',
      //   bind: 'residueDay'
      // },
      {
        label: "剩余日期",
        type: "custInfo",
        sort: "remind_date",
        text: [
          {
            bind: "residueDay"
          }
        ],

        options: [
          {
            label: "由低到高",
            value: "asc"
          },
          {
            label: "由高到低",
            value: "desc"
          }
        ]
      },
      {
        type: "custInfo",
        label: "备注",
        text: [
          {
            bind: "remark"
          }
        ],
        minWidth: 100
      },
      {
        type: "accountStatus",
        label: "操作",
        align: "center",
        showButton () {
          return that.getPermission(
            that.$permissionData.DeleteAccount.englishName
          );
        },
        remove: async row => {
          try {
            let confirm = await vm._confirm("是否确认删除该账号");
            if (confirm) {
              mediafax
                .removeMediafaxAccount({ id: row.id })
                .then(res => {
                  if (res) vm._success("删除成功");
                  that.query();
                })
                .catch(err => {
                  if (err)
                    vm._info(
                      "当前运营账号下绑定了客户主页，请将客户主页迁移之后再进行删除操作。"
                    );
                });
            }
          } catch (e) {
            console.error(e);
            vm._info("取消删除");
          }
        },
        retry: function (row) {
          that.auth(row.id, row.mediaPlatform);
        }
      }
    ];
    return {
      groups: groups,
      column: column,
      dialogVisible: false,
      btnLoading: false,
      formData: {},
      platform: "",
      accountForm: {
        account: "",
        genre: "",
        platformCode: "",
        remark: ""
      }
    };
  },
  computed: {},
  watch: {},
  mounted () {
    // this.query();
    this.setFormData();
  },
  methods: {
    close () {
      this.accountForm = {
        account: "",
        genre: "",
        platformCode: "",
        remark: ""
      };
      this.setFormData();
    },
    auth (id, platform) {
      account
        .getAuthUrl({
          id: id,
          // platform: platform,
          url: location.href
        })
        .then(val => {
          if (val.data) {
            location.href = val.data;
          }
        });
    },
    submit () {
      this.btnLoading = true;
      let requestApi = api.account.addAccount;
      let type = "Post";
      let msg = "新增";
      if (this.accountForm.id) {
        requestApi = api.account.editAccount;
        type = "Put";
        msg = "修改";
      }
      simpleFormPageCreate(
        {
          api: requestApi,
          type: type,
          data: this.formData
        },
        res => {
          this.platform = res.platformCode;
          if (this.accountForm.id) {
            return {
              id: this.accountForm.id,
              remark: res.remark
            };
          }
          return res;
        }
      )
        .submit()
        .then(val => {
          if (val.data) {
            this.$message({
              message: msg + "成功",
              type: "success"
            });
          }
          this.btnLoading = false;
          if (!this.accountForm.id) {
            this.auth(val.data, this.platform);
          } else {
            this.query();
            this.dialogVisible = false;
          }
        })
        .catch(err => {
          this.btnLoading = false;
        });
    },
    setFormData () {
      this.formData = {
        account: {
          label: "运营账号",
          formType: "sky-input",
          value: this.accountForm.account,
          disabled: Boolean(this.accountForm.id),
          options: []
        },
        genre: {
          label: "账号归属",
          formType: "sky-radio",
          options: genreSatus,
          value: this.accountForm.genre,
          disabled: Boolean(this.accountForm.id)
        },
        remark: {
          label: "备注",
          formType: "sky-textarea",
          value: this.accountForm.remark
        }
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.row-bg {
  background: #fff;
  margin: 10px 0;
  padding: 10px;
}
</style>